import {
    ChangeDetectorRef, Component, OnInit, OnDestroy, effect, ViewEncapsulation
    , ComponentFactoryResolver, AfterViewInit,
    inject,
    computed,
    TemplateRef,
    ViewChild,
    model,
    HostListener,
    input,
} from '@angular/core';
import { DynamicFormStore } from '@itm/store/states/dynamic-form.state';
import { TimelineAllModule, TimelineItemModel, TimelineModule } from '@syncfusion/ej2-angular-layouts';
import { CommonModule } from '@angular/common';
import { ItmBaseComponent } from '../itm.base.component';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs';
import { AuditService } from '@itm/services/audit.service';
import { AuditAction, DateTimeFormation, Utilities } from '@itm/constants/utilities';
import { IControl } from '@itm/types';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import moment from 'moment-timezone';
import { ActionType, IActions } from 'app/modules/admin/cac/utilities';

@Component({
    selector: 'itm-audit-detail',
    standalone: true,
    imports: [
        TimelineModule, TimelineAllModule, CommonModule, GridModule
    ],
    templateUrl: './audit-detail.component.html',
    styleUrl: './audit-detail.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class AuditDetailComponent extends ItmBaseComponent implements OnInit, OnDestroy, AfterViewInit {

    additionalHeight: number = 70;
    containerHeight: any = 0;

    actionData = input<IActions>();

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        const innerWidth = event.target.innerWidth;
        const innerHeight = event.target.innerHeight;
        this.containerHeight = innerHeight - this.additionalHeight;

        // const parentDiv = document.getElementById('auditInnerContainer');
        // if (parentDiv) {
        //     (parentDiv as HTMLElement).style.height = this.containerHeight + 'px';
        // }
    }
  
    readonly _formStore = inject(DynamicFormStore);
    readonly _auditService = inject(AuditService);

    ActionType = ActionType;
    auditAction = AuditAction;
    dateTimeFormation = DateTimeFormation;

    controlSig = model<IControl>(undefined);

    entityId = this._formStore.entityId;
    entityId$ = toObservable(this.entityId);
    entity$ = this.entityId$.pipe(
        takeUntil(this._unsubscribeAll),
        // tap(x => console.log('entityId$', x)),
        filter(x => x != undefined),
        filter(x => x != Utilities.EMPTY_NEW),
        switchMap(x => this._auditService.getById(x)
        .pipe(
            map((x: any) => {
                if (x.data) {
                    const result = x.data.data;
                    const editTitle = this.getPropValueCaseInsensitive(result, this.controlSig()?.editTitle);
                    if (editTitle) {
                        this._globalStore.setEditTitle(editTitle);
                    }
                    return result;
                }
                else {
                    this._toastr.showError(x.error)
                }
            }),
            tap(x => {
            }),
        ))
    )
    entitySig = toSignal(this.entity$);
    
    audit = computed(() => {
        const entity = this.entitySig();
        return {
            ...entity,
            auditChanges: entity?.auditChanges.map((ac: any) => {
                let cssClass = 'create';
                switch (ac.action) {
                    case this.auditAction.create:
                        cssClass = 'create';
                        break;
                    case this.auditAction.update:
                        cssClass = 'update';
                        break;
                    case this.auditAction.approve:
                        cssClass = 'approve';
                        break;
                    case this.auditAction.reject:
                        cssClass = 'reject';
                        break;
                    case this.auditAction.rejectComment:
                        cssClass = 'reject';
                        break;
                    case this.auditAction.requesterComment:
                        cssClass = 'req-comment';
                        break;
                    case this.auditAction.approverComment:
                        cssClass = 'app-comment';
                        break;
                    case this.auditAction.complete:
                        cssClass = 'complete';
                        break;
                    case this.auditAction.autoEscalated:
                        cssClass = 'auto-escalated';
                        break;
                    case this.auditAction.approver:
                        cssClass = 'approver';
                        break;
                    case this.auditAction.requester:
                        cssClass = 'requester';
                        break;
                    case this.auditAction.moveNext:
                        cssClass = 'movenext';
                        break;
                    case this.auditAction.cancel:
                        cssClass = 'cancel';
                        break;
                }
                return {
                    ...ac,
                    cssClass: cssClass,
                }
            })
        };
    });

    auditChanges = computed(() => {
        // console.log(this.audit())
        return this.audit()?.auditChanges;
    });
    
    CUSTOM_CATEGORY_DATA_STR = 'customcategorydata';

    constructor(private cfr: ComponentFactoryResolver
        , private cdr: ChangeDetectorRef) {
        super();

        effect(() => {
            // console.log(this.audit(), this.controlSig())
        });
    }

    ngOnInit(): void {
        this.setInnerContainerHeight();
    }

    ngAfterViewInit() {
        // this.cdr.markForCheck();
    }

    ngOnDestroy(): void {
        // this._unsubscribeAll.next(null);
        // this._unsubscribeAll.complete();
    }
    
    getPropValueCaseInsensitive(obj: any, key: any) {
        if (!key) return undefined;
        const lowerCaseKey = key.toLowerCase();
        for (const k in obj) {
            if (obj.hasOwnProperty(k) && k.toLowerCase() === this.CUSTOM_CATEGORY_DATA_STR) {
                const filteredVal = obj[k].filter((x: any) => x.customCategoryId.toLowerCase() == lowerCaseKey);
                if (filteredVal.length > 0) {
                    return filteredVal[0].value;
                }
                return null;
            }
            else if (obj.hasOwnProperty(k) && k.toLowerCase() === lowerCaseKey) {
                return obj[k];
            }
        }
        return undefined; // or any default value you prefer
    }

    getTitleChange(index: number) {
        return this.auditChanges()?.[index]?.changes.find((f: any) => f.name === 'title');
    }

    getSubTitleChange(index: number) {
        return this.auditChanges()?.[index]?.changes.find((f: any) => f.name === 'subTitle');
    }

    getDetailsChange(index: number) {
        return this.auditChanges()?.[index]?.changes.find((f: any) => f.name === 'details');
    }

    getBgClass(index: number){
        return 'details-sec'
    }

    setInnerContainerHeight(){
    //   const innerHeight = window.innerHeight;
    //   this.containerHeight = innerHeight - this.additionalHeight;
  
    //   const parentDiv = document.getElementById('auditInnerContainer');
    //   if (parentDiv) {
    //     (parentDiv as HTMLElement).style.height = this.containerHeight + 'px';
    //   }
    }
}
